var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M256,384c-70.578,0-128-57.422-128-128s57.422-128,128-128s128,57.422,128,128S326.578,384,256,384z   M256,154.483c-55.978,0-101.517,45.539-101.517,101.517S200.022,357.517,256,357.517S357.517,311.978,357.517,256  S311.978,154.483,256,154.483z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M256,375.172c-65.711,0-119.172-53.461-119.172-119.172S190.289,136.828,256,136.828   S375.172,190.289,375.172,256S321.711,375.172,256,375.172z M256,145.655c-60.845,0-110.345,49.5-110.345,110.345   S195.155,366.345,256,366.345S366.345,316.845,366.345,256S316.845,145.655,256,145.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M149.292,252.246c3.214,7.701-4.103,15.019-11.805,11.805c-1.932-0.806-3.491-2.365-4.297-4.297   c-3.214-7.701,4.103-15.019,11.805-11.805C146.927,248.755,148.486,250.314,149.292,252.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M378.81,252.246c3.214,7.701-4.103,15.019-11.805,11.805c-1.932-0.806-3.491-2.365-4.297-4.297   c-3.214-7.701,4.103-15.019,11.805-11.805C376.445,248.755,378.003,250.314,378.81,252.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M259.754,149.292c-7.701,3.214-15.019-4.103-11.805-11.805c0.806-1.932,2.365-3.491,4.297-4.297   c7.701-3.214,15.019,4.103,11.805,11.805C263.245,146.927,261.686,148.486,259.754,149.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M183.201,177.892c-3.173,7.719-13.522,7.719-16.695,0c-0.796-1.936-0.796-4.141,0-6.077   c3.173-7.719,13.522-7.719,16.695,0C183.997,173.751,183.997,175.956,183.201,177.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M334.108,183.201c-7.719-3.173-7.719-13.522,0-16.695c1.936-0.796,4.141-0.796,6.077,0   c7.719,3.173,7.719,13.522,0,16.695C338.249,183.997,336.044,183.997,334.108,183.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M368.025,205.535c5.917,5.885,1.957,15.446-6.389,15.424c-2.094-0.006-4.13-0.849-5.615-2.326   c-5.917-5.885-1.957-15.446,6.389-15.424C364.504,203.215,366.54,204.058,368.025,205.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M218.633,155.979c-5.885,5.917-15.446,1.956-15.424-6.389c0.006-2.094,0.849-4.13,2.326-5.615   c5.885-5.917,15.446-1.957,15.424,6.389C220.953,152.458,220.109,154.494,218.633,155.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M158.852,211.697c0.022,8.345-9.539,12.306-15.424,6.389c-1.476-1.484-2.32-3.521-2.326-5.615   c-0.022-8.345,9.539-12.306,15.424-6.389C158.002,207.566,158.846,209.603,158.852,211.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M300.303,158.852c-8.345,0.022-12.306-9.539-6.389-15.424c1.484-1.476,3.521-2.32,5.615-2.326   c8.345-0.022,12.306,9.539,6.389,15.424C304.434,158.002,302.397,158.846,300.303,158.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M375.718,228.359c4.655,6.926-1.095,15.531-9.275,13.881c-2.052-0.414-3.885-1.639-5.053-3.376   c-4.655-6.926,1.095-15.531,9.275-13.881C372.717,225.397,374.55,226.622,375.718,228.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M238.864,150.611c-6.926,4.655-15.531-1.095-13.881-9.275c0.414-2.052,1.639-3.885,3.376-5.053   c6.926-4.655,15.531,1.095,13.881,9.275C241.826,147.61,240.602,149.443,238.864,150.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M169.361,193.595c-1.606,8.189-11.756,10.208-16.374,3.257c-1.159-1.744-1.589-3.906-1.186-5.96   c1.606-8.189,11.756-10.208,16.374-3.257C169.334,189.379,169.764,191.541,169.361,193.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M318.405,169.361c-8.189-1.606-10.208-11.756-3.257-16.374c1.744-1.159,3.906-1.589,5.96-1.186   c8.189,1.606,10.208,11.756,3.257,16.374C322.621,169.334,320.459,169.764,318.405,169.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M356.027,184.649c6.951,4.618,4.932,14.768-3.257,16.374c-2.055,0.403-4.217-0.027-5.96-1.186   c-6.951-4.618-4.932-14.768,3.257-16.374C352.121,183.061,354.283,183.491,356.027,184.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M199.838,165.19c-4.618,6.951-14.768,4.932-16.374-3.257c-0.403-2.055,0.027-4.217,1.186-5.96   c4.618-6.951,14.768-4.932,16.374,3.257C201.426,161.285,200.996,163.446,199.838,165.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M152.075,231.501c1.65,8.181-6.955,13.93-13.881,9.275c-1.738-1.168-2.962-3.001-3.376-5.053   c-1.65-8.181,6.955-13.93,13.881-9.275C150.437,227.615,151.661,229.448,152.075,231.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC00"
    },
    d: "M280.499,152.075c-8.181,1.65-13.93-6.955-9.275-13.881c1.168-1.738,3.001-2.962,5.053-3.376   c8.181-1.65,13.93,6.955,9.275,13.881C284.385,150.437,282.552,151.661,280.499,152.075z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M370.759,260.414c-2.44,0-4.414-1.974-4.414-4.414c0-60.845-49.5-110.345-110.345-110.345  S145.655,195.155,145.655,256c0,2.44-1.974,4.414-4.414,4.414s-4.414-1.974-4.414-4.414c0-65.711,53.461-119.172,119.172-119.172  S375.172,190.289,375.172,256C375.172,258.44,373.198,260.414,370.759,260.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4B4B4"
    },
    d: "M280.527,388.414h-49.054c-10.482,0-18.655-9.079-17.558-19.503l15.602-148.221h52.966  l15.602,148.221C299.182,379.335,291.009,388.414,280.527,388.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAAAAA"
    },
    d: "M282.232,220.69h-52.671c-2.321,0-4.269-1.748-4.52-4.056l-3.29-30.302  c-0.567-5.222,3.523-9.781,8.776-9.781h50.945c5.253,0,9.343,4.559,8.776,9.781l-3.268,30.097  C286.717,218.853,284.671,220.69,282.232,220.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.044,186.833l16.364,47.078l49.831,1.015c2.051,0.042,2.899,2.649,1.263,3.888l-39.717,30.111  l14.433,47.706c0.594,1.964-1.623,3.575-3.308,2.403L256,290.567l-40.911,28.468c-1.684,1.172-3.902-0.439-3.308-2.403  l14.433-47.706l-39.717-30.111c-1.635-1.24-0.788-3.847,1.263-3.888l49.831-1.015l16.364-47.078  C254.629,184.895,257.371,184.895,258.044,186.833z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.4cfd4b306d75ac1f5b1e1db19c876fec.svg";
export { ForwardRef as ReactComponent };